<ng-container *ngIf="tenantId">
  <ng-template
    [requireClaims]="{ type: 'system', value: true }"
    (requireFailed)="checkFailed = true">
    <a
      target="_blank"
      class="link-underline-light fw-light"
      [ngClass]="ngClass"
      [routerLink]="['/tenants/preview', tenantId]">{{tenantId}}</a>
  </ng-template>
  <span
    *ngIf="checkFailed"
    class="text-secondary fw-light"
    [ngClass]="ngClass"
  >{{tenantId}}<span class="fw-bold">*</span></span>
</ng-container>
